import { POST_ANALYTICS_ROUTE } from "pages/PostAnalytics/postAnalyticsFixtures";

// TODO: Leaving this hook as there's a future ticket to customize the default business route
// Re-use this hook at that time to redirect to the default route the user has set up in their
// business preferences
const useDefaultBusinessRoute = () => POST_ANALYTICS_ROUTE;

export default useDefaultBusinessRoute;
